import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["videoTimestamp", "videoEndTime", "language"];
import { extractEmbedParametersFromAcademyUrl, StaticContentWidget } from 'embedded-academy-lib';
import { View } from 'foundations-components/components/View';
import unescapedText from 'I18n/utils/unescapedText';
import { InlineAcademyVideoResponseSectionTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_ACADEMY_LANGUAGE = 'EN';
const isChadminUI = () => {
  try {
    return window.location.href.includes('hubteam.com/chadmin-ui') || window.location.href.includes('hubteamqa.com/chadmin-ui');
  } catch (___error) {
    return false;
  }
};
const InlineAcademyVideo = ({
  section
}) => {
  /**
   * HubSpot Academy is within the authenticated HubSpot experience,
   * so the videos require app auth by default. In order for the
   * videos to load when viewing a thread in chadmin, we need to
   * set it to use public auth.
   */
  const usePublicAuth = isChadminUI();
  if (section.__typename !== InlineAcademyVideoResponseSectionTypename || !section.url) {
    return null;
  }
  const _extractEmbedParamete = extractEmbedParametersFromAcademyUrl(section.url),
    {
      videoTimestamp,
      videoEndTime,
      language
    } = _extractEmbedParamete,
    embedParams = _objectWithoutPropertiesLoose(_extractEmbedParamete, _excluded);
  return /*#__PURE__*/_jsx(View, {
    marginBlock: "300",
    maxInlineSize: "400px",
    children: /*#__PURE__*/_jsx(StaticContentWidget, Object.assign({
      authType: usePublicAuth ? 'public' : undefined,
      name: unescapedText('chatspotComponents.sections.dynamicSectionFormatter.academyVideo'),
      language: language || DEFAULT_ACADEMY_LANGUAGE
    }, embedParams, {
      startTime: videoTimestamp === null || videoTimestamp === void 0 ? void 0 : videoTimestamp.toString(),
      sectionEndTime: videoEndTime === null || videoEndTime === void 0 ? void 0 : videoEndTime.toString(),
      linkTextProps: {
        typography: 'link-25'
      },
      videoWrapperProps: {
        borderRadius: '200',
        marginBlockEnd: '200',
        overflow: 'hidden'
      }
    }))
  });
};
export default InlineAcademyVideo;